import { c as _c } from "react/compiler-runtime";
import type { ActivityLogParams } from "@/components/profile-activity/ProfileActivityLogs";
import type { ApiRepCategory } from "@/generated/models/ApiRepCategory";
import type { ApiRepOverview } from "@/generated/models/ApiRepOverview";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { RateMatter } from "@/types/enums";
import type { RepDirection } from "./UserPageRep.helpers";
import RepDirectionToggle from "./RepDirectionToggle";
import RepCategoryPill from "./RepCategoryPill";
import UserPageCombinedActivityLog from "./UserPageCombinedActivityLog";
import UserPageRateWrapper from "../utils/rate/UserPageRateWrapper";
function RepEmptyState(t0) {
  const $ = _c(3);
  const {
    loading,
    repDirection
  } = t0;
  if (loading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="tw-mt-4 tw-flex tw-justify-center tw-py-4"><div className="tw-h-5 tw-w-5 tw-animate-spin tw-rounded-full tw-border-2 tw-border-solid tw-border-iron-700 tw-border-t-iron-400" /></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const t1 = repDirection === "given" ? "No rep given yet." : "No rep received yet.";
  let t2;
  if ($[1] !== t1) {
    t2 = <p className="tw-mb-0 tw-mt-4 tw-text-sm tw-font-normal tw-text-iron-500">{t1}</p>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export default function MobileRepTabContent(t0) {
  const $ = _c(33);
  const {
    profile,
    overview,
    categories,
    repDirection,
    onRepDirectionChange,
    initialActivityLogParams,
    loading,
    canEditRep,
    visibleCount,
    onShowMore,
    onGrantRep,
    onEditCategory
  } = t0;
  let t1;
  if ($[0] !== canEditRep || $[1] !== onGrantRep || $[2] !== overview || $[3] !== profile || $[4] !== repDirection) {
    t1 = canEditRep && repDirection === "received" && <div className="tw-mt-4"><UserPageRateWrapper profile={profile} type={RateMatter.REP} hideOwnProfileMessage={true}><button type="button" onClick={onGrantRep} className="tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-rounded-xl tw-border tw-border-solid tw-border-blue-500/30 tw-bg-blue-400/5 tw-px-4 tw-py-2.5 tw-transition tw-duration-300 tw-ease-out hover:tw-bg-blue-400/10">{overview !== null && overview.authenticated_user_contribution !== null && overview.authenticated_user_contribution !== 0 ? <span className="tw-flex tw-items-center tw-gap-1.5 tw-text-xs tw-font-medium tw-text-iron-500">You Assigned:{" "}<span className="tw-font-semibold tw-text-iron-300">{overview.authenticated_user_contribution > 0 && "+"}{formatNumberWithCommas(overview.authenticated_user_contribution)}</span></span> : <span className="tw-text-xs tw-font-medium tw-text-blue-300/70">Add rep to this identity</span>}<span className="tw-flex tw-flex-shrink-0 tw-items-center tw-gap-1.5 tw-rounded-lg tw-border tw-border-solid tw-border-primary-500 tw-bg-primary-500 tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-text-white"><svg className="-tw-ml-1 tw-h-3.5 tw-w-3.5 tw-flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>Grant Rep</span></button></UserPageRateWrapper></div>;
    $[0] = canEditRep;
    $[1] = onGrantRep;
    $[2] = overview;
    $[3] = profile;
    $[4] = repDirection;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== overview || $[7] !== repDirection) {
    t2 = repDirection === "given" && overview !== null && overview.authenticated_user_contribution !== null && overview.authenticated_user_contribution !== 0 && <div className="tw-mt-4 tw-flex tw-items-center tw-gap-1.5 tw-rounded-xl tw-border tw-border-solid tw-border-blue-500/20 tw-bg-blue-400/5 tw-px-4 tw-py-2.5"><span className="tw-text-xs tw-font-medium tw-text-iron-500">Assigned To You:</span><span className="tw-text-xs tw-font-semibold tw-text-iron-300">{overview.authenticated_user_contribution > 0 && "+"}{formatNumberWithCommas(overview.authenticated_user_contribution)}</span></div>;
    $[6] = overview;
    $[7] = repDirection;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-mb-4 tw-whitespace-nowrap tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">Rep Categories</div>;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== onRepDirectionChange || $[11] !== repDirection) {
    t4 = <div className="tw-mt-4">{t3}<div className="tw-mb-3"><RepDirectionToggle repDirection={repDirection} onRepDirectionChange={onRepDirectionChange} compact={true} /></div></div>;
    $[10] = onRepDirectionChange;
    $[11] = repDirection;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== canEditRep || $[14] !== categories || $[15] !== onEditCategory || $[16] !== onShowMore || $[17] !== repDirection || $[18] !== visibleCount) {
    t5 = categories.length > 0 && <div><div className="tw-flex tw-flex-wrap tw-gap-2">{categories.slice(0, visibleCount).map(cat => <RepCategoryPill key={cat.category} category={cat} canEdit={canEditRep && repDirection === "received"} onEdit={onEditCategory} direction={repDirection} compact={true} />)}{categories.length > visibleCount && <button type="button" onClick={onShowMore} className="tw-inline-flex tw-cursor-pointer tw-items-center tw-gap-2.5 tw-rounded-lg tw-border tw-border-solid tw-border-iron-700/60 tw-bg-iron-900/60 tw-px-4 tw-py-2.5 tw-text-xs tw-font-semibold tw-text-iron-400 tw-transition-colors hover:tw-border-iron-600/60 hover:tw-bg-iron-800/60 hover:tw-text-iron-300">+{categories.length - visibleCount} more</button>}</div></div>;
    $[13] = canEditRep;
    $[14] = categories;
    $[15] = onEditCategory;
    $[16] = onShowMore;
    $[17] = repDirection;
    $[18] = visibleCount;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== categories.length || $[21] !== loading || $[22] !== repDirection) {
    t6 = categories.length === 0 && <RepEmptyState loading={loading} repDirection={repDirection} />;
    $[20] = categories.length;
    $[21] = loading;
    $[22] = repDirection;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== initialActivityLogParams) {
    t7 = <div className="tw-mt-6"><UserPageCombinedActivityLog initialActivityLogParams={initialActivityLogParams} matter={RateMatter.REP} withMatterFilter={false} /></div>;
    $[24] = initialActivityLogParams;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== t1 || $[27] !== t2 || $[28] !== t4 || $[29] !== t5 || $[30] !== t6 || $[31] !== t7) {
    t8 = <>{t1}{t2}{t4}{t5}{t6}{t7}</>;
    $[26] = t1;
    $[27] = t2;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  return t8;
}